import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer4 from "../layout/footer4";
import ScrollToTop from "../element/scrollToTop";
import { projectContent1, homeSliderContent8 } from "../element/SliderContent";
import ProjectSlider1 from "../element/projectSlider1";
import ClientSlider1 from "../element/clientSlider1";
import CounterSection2 from "../element/counterSection2";
import HomeSlider1 from "../element/homeslider1";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import "../../css/plugins.css";
import "../../css/style.css";
import "../../css/skin/skin-1.css";
import "../../css/templete.min.css";

const bg2 = require("../../images/3.png");
const shedPic = require("../../images/CastomechShed.jpeg");
const machinePic = require("../../images/castomech1.png");
const aboutPic = require("../../images/castomech-shad.png");

// Advanced Premium Light Mode Theme
const premiumLightStyles = `
  :root {
    --light-bg: #ffffff;
    --soft-bg: #f8fafc;
    --mesh-bg-1: #fff1f2;
    --mesh-bg-2: #fff7ed;
    --card-bg: #ffffff;
    --brand-orange: #ff4b2b;
    --brand-red: #ff416c;
    --text-main: #0f172a;
    --text-muted: #475569; /* Updated from #64748b */
    --border-color: #e2e8f0;
  }

  * {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden !important;
    width: 100%;
    background-color: var(--light-bg) !important;
    color: var(--text-main) !important;
    font-family: 'Inter', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--text-main);
  }

  /* --- Premium Light Hero Section --- */
  .premium-hero {
    position: relative;
    height: 100vh;
    min-height: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #ffffff;
  }

  .unique-light-banner {
    background: #ffffff;
    position: relative;
    overflow: hidden;
  }
  
  .unique-light-banner .home-slider2 {
    height: 100vh;
    min-height: 800px;
  }

  .slider-content {
    background-color: #ffffff !important;
  }

  .sliderStyleLight {
    padding: 0 10% !important;
    width: 100% !important;
    max-width: 1600px !important;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    position: relative;
    z-index: 10;
  }
  
  .sliderStyleLight span {
    color: var(--brand-orange) !important;
    font-weight: 800 !important;
    font-size: 14px !important;
    letter-spacing: 3px !important;
    text-transform: uppercase;
    display: block;
    margin-bottom: 20px;
  }

  .sliderStyleLight h1 {
    font-size: 5rem !important;
    font-weight: 900 !important;
    color: #ffffff !important;
    margin-bottom: 25px !important;
    line-height: 1 !important;
    letter-spacing: -2px !important;
    max-width: 700px;
    text-shadow: 0 4px 10px rgba(0,0,0,0.3);
  }
  
  .sliderStyleLight p {
    font-size: 1.25rem !important;
    color: rgba(255,255,255,0.9) !important;
    line-height: 1.6 !important;
    max-width: 600px !important;
    margin-bottom: 40px !important;
    font-weight: 500 !important;
    text-shadow: 0 2px 5px rgba(0,0,0,0.3);
  }

  .premium-btn {
    padding: 18px 45px !important;
    font-size: 16px !important;
    background: var(--brand-orange) !important;
    color: white !important;
    border-radius: 12px !important;
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
    border: none;
    font-weight: 700 !important;
    display: inline-block;
    letter-spacing: 1px;
    text-transform: uppercase;
    box-shadow: 0 15px 30px rgba(255, 75, 43, 0.3);
  }

  .premium-btn:hover {
    background: #ffffff !important;
    color: var(--brand-orange) !important;
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }

  /* Slider image specific positioning */
  .unique-light-banner .slider-content {
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
  
  /* Modern Dark Overlay for text protection */
  .unique-light-banner .slider-content::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(90deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%) !important;
    z-index: 1;
  }
  
  /* Unique Navigation buttons for light theme */
  .unique-light-banner .swiper-button {
    position: absolute;
    bottom: 50px;
    right: 10%;
    display: flex;
    gap: 15px;
    z-index: 20;
  }
  
  .unique-light-banner .previousButton,
  .unique-light-banner .nextButton {
    position: static !important;
    width: 50px !important;
    height: 50px !important;
    background: #0f172a !important;
    border-radius: 50% !important;
    color: white !important;
    transform: scale(1.1) !important;
  }

  /* Animated Blob Overlay */
  .animated-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    z-index: 2;
    opacity: 0.5;
    animation: blobFloat 15s ease-in-out infinite alternate;
  }
  .blob-1 {
    top: -10%; left: -10%;
    width: 600px; height: 600px;
    background: rgba(255, 75, 43, 0.15);
  }
  .blob-2 {
    bottom: -10%; right: -10%;
    width: 700px; height: 700px;
    background: rgba(255, 65, 108, 0.15);
    animation-delay: -5s;
    animation-direction: alternate-reverse;
  }
  @keyframes blobFloat {
    0% { transform: scale(1) translate(0px, 0px); }
    33% { transform: scale(1.2) translate(100px, -50px); }
    66% { transform: scale(0.8) translate(-50px, 100px); }
    100% { transform: scale(1.1) translate(50px, 50px); }
  }

  /* --- Section Labels --- */
  .light-section-label {
    display: inline-flex;
    align-items: center;
    color: var(--brand-orange);
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .light-section-label::before {
    content: '';
    display: inline-block;
    width: 40px; height: 2px;
    background: var(--brand-orange);
    margin-right: 15px;
  }

  .light-section-title {
    font-size: 3rem;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 20px;
    color: var(--text-main);
  }

  /* --- Products Section --- */
  .products-light-section {
    padding: 100px 0 140px;
    background: #ffffff;
    position: relative;
    border-top: 1px solid #eee;
  }

  .project-carousel-wrapper {
    padding: 20px 0;
  }

  /* Customizing slick slider for light mode */
  .dlab-box {
    background: #ffffff !important;
    border: 1px solid #eee;
    border-radius: 8px !important;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 10px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  }
  .dlab-box:hover {
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    border-color: #ddd;
  }
  .project-bx .dlab-media {
     background: #f9f9f9;
     border-bottom: 1px solid #eee;
  }
  .project-bx .dlab-media img {
    height: 280px !important;
    width: 100% !important;
    object-fit: contain !important;
    padding: 15px;
  }
  .dlab-info {
    padding: 20px !important;
    text-align: center;
    background: white !important;
  }
  .dlab-title {
    margin: 0 !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
  }
  .dlab-title a {
    color: #333 !important;
    text-decoration: none !important;
  }
  .dlab-box:hover .dlab-title a {
    color: var(--brand-orange) !important;
  }

  /* --- Premium Features Grid --- */
  .premium-features-section {
    padding: 120px 0;
    background: var(--light-bg);
  }

  .premium-feature-card {
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    position: relative;
    padding: 50px 40px;
    border-radius: 24px;
    height: 100%;
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 10px 30px rgba(0,0,0,0.02);
    overflow: hidden;
    z-index: 1;
  }

  .premium-feature-card::before {
    content: "";
    position: absolute;
    top: 0; left: 0; width: 100%; height: 0;
    background: linear-gradient(180deg, rgba(255, 65, 108, 0.05) 0%, transparent 100%);
    z-index: -1;
    transition: height 0.5s ease;
  }

  .premium-feature-card:hover {
    transform: translateY(-15px);
    box-shadow: 0 30px 60px rgba(0,0,0,0.08);
    border-color: rgba(255, 75, 43, 0.2);
  }

  .premium-feature-card:hover::before {
    height: 100%;
  }

  .premium-icon-box {
    width: 80px; height: 80px;
    background: var(--soft-bg);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }

  .premium-icon {
    width: 45px;
    height: 45px;
    object-fit: contain;
    display: block;
  }

  .premium-feature-card h3 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 20px;
    color: var(--text-main);
  }
  
  .premium-feature-card p {
    color: var(--text-muted);
    line-height: 1.7;
  }

  /* --- Premium About Section --- */
  .premium-about-section {
    padding: 130px 0;
    background: var(--light-bg);
    position: relative;
    overflow: hidden;
  }

  .about-image-wrapper {
    position: relative;
    padding-right: 40px;
    z-index: 1;
  }

  .about-img-main {
    width: 100%;
    border-radius: 30px;
    box-shadow: 0 30px 60px rgba(0,0,0,0.08);
  }

  .about-img-shape {
    position: absolute;
    bottom: -30px;
    right: 0;
    width: 250px;
    height: 250px;
    background: linear-gradient(135deg, var(--brand-red), var(--brand-orange));
    border-radius: 30px;
    z-index: -1;
    transform: rotate(10deg);
  }

  .about-stats-box {
    margin-top: 30px;
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
    border-left: 4px solid var(--brand-orange);
  }

  .about-stats-number {
    font-size: 4rem;
    font-weight: 900;
    color: var(--brand-orange);
    line-height: 1;
  }

  .about-stats-text {
    font-size: 14px;
    font-weight: 600;
    color: #444;
    text-transform: uppercase;
    line-height: 1.2;
  }

  /* Slick Arrow Styles */
  .products-light-section .slick-prev,
  .products-light-section .slick-next {
    width: 60px;
    height: 60px;
    background: #ffffff !important;
    border-radius: 50%;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    z-index: 10;
    transition: all 0.3s ease;
  }
  .products-light-section .slick-prev:before,
  .products-light-section .slick-next:before {
    color: var(--brand-orange);
    font-size: 30px;
    opacity: 1;
  }
  .products-light-section .slick-prev { left: -30px; }
  .products-light-section .slick-next { right: -30px; }
  .products-light-section .slick-prev:hover,
  .products-light-section .slick-next:hover {
    background: var(--brand-orange) !important;
    transform: scale(1.1);
  }
  .products-light-section .slick-prev:hover:before,
  .products-light-section .slick-next:hover:before {
    color: #ffffff;
  }

  /* --- Global elements updates --- */
  .site-header .premium-btn-header {
    background: #0f172a !important;
    color: white !important;
    padding: 12px 30px !important;
    border-radius: 8px !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    transition: all 0.3s ease !important;
  }
  .site-header .premium-btn-header:hover {
    background: var(--brand-orange) !important;
    transform: translateY(-2px);
  }

  @media(max-width: 991px) {
    .premium-title { font-size: 3rem; }
    .hero-text-side { padding-right: 0; margin-bottom: 40px; text-align: center; }
    .hero-content-wrapper { flex-direction: column; justify-content: center; padding-top: 100px; }
    .light-section-label { justify-content: center; }
  }

  /* --- Popup Modal Styles --- */
  .popup-overlay {
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(15, 23, 42, 0.9);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
    animation: fadeInModal 0.4s ease;
  }
  @keyframes fadeInModal {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .popup-content {
    background: #ffffff;
    width: 100%;
    max-width: 500px;
    padding: 50px;
    border-radius: 30px;
    position: relative;
    box-shadow: 0 40px 100px rgba(0,0,0,0.3);
    animation: slideUpModal 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  @keyframes slideUpModal {
    from { transform: translateY(50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  .close-button {
    position: absolute;
    top: 25px;
    right: 25px;
    background: #f1f5f9;
    border: none;
    font-size: 24px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    color: #475569;
  }
  .close-button:hover {
    background: #ff4b2b;
    color: white;
    transform: rotate(90deg);
  }
  .popup-title {
    font-size: 28px;
    font-weight: 800;
    margin-bottom: 5px;
    color: #0f172a;
  }
  .popup-subtitle {
    color: #64748b;
    margin-bottom: 35px;
    font-size: 15px;
  }
  .popup-form-group {
    margin-bottom: 25px;
  }
  .popup-form-group label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .popup-form-group input {
    width: 100%;
    height: 55px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 0 20px;
    font-size: 15px;
    transition: all 0.3s;
  }
  .popup-form-group input:focus {
    border-color: #ff4b2b;
    background: white;
    outline: none;
    box-shadow: 0 0 0 4px rgba(255, 75, 43, 0.1);
  }
  .success-message {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #10b981;
  }
  .disabled-button {
    opacity: 0.6;
    cursor: not-allowed !important;
  }
`;

const Index = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    emailjs.init("IDZukK49bAWi8Pkt0");

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "" });
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [captchaToken, setCaptchaToken] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRecaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => {
    setIsPopupOpen(false);
    setAlert({ message: "", type: "" });
    setCaptchaToken("");
  };

  const handleDownload = () => {
    const urls = [
      "/pdf/Castomech Catalogue 1.pdf",
      "/pdf/Castomech Catalogue 2.pdf"
    ];
    urls.forEach((url, i) => {
      const link = document.createElement("a");
      link.href = process.env.PUBLIC_URL + url;
      link.download = "Castomech Catalogue " + (i + 1) + ".pdf";
      link.style.display = "none";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, i * 500);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const templateParams = { 
      name: formData.name, 
      email: formData.email, 
      mobile: formData.mobile,
      phone: formData.mobile // Ensure both phone and mobile keys work
    };

    emailjs
      .send(
        "service_28emj8y",
        "template_2rotnxq",
        templateParams,
        "IDZukK49bAWi8Pkt0"
      )
      .then(() => {
        setAlert({
          message: "Details submitted successfully! Thank you.",
          type: "success",
        });
        handleDownload();
        setTimeout(() => closePopup(), 3000);
      })
      .catch((error) => {
        setAlert({
          message: "Failed to submit details. Please try again.",
          type: "error",
        });
      });
  };

  return (
    <div className="skin-1" style={{ background: "#ffffff" }}>
      <style dangerouslySetInnerHTML={{ __html: premiumLightStyles }} />

      {/* Dynamic Header */}
      <div style={{ position: "relative", zIndex: 1000 }}>
        <Header />
      </div>

      {/* 1. UNIQUE LIGHT SLIDER BANNER */}
      <section className="unique-light-banner">
        {/* Animated Overlays */}
        <HomeSlider1
          data={homeSliderContent8}
          contentWrapperCls="sliderStyleLight"
          btnText="DOWNLOAD BROCHURE"
          btnCls="premium-btn"
          hideBtn={false}
          onBtnClick={openPopup}
        />

        {/* Custom SVG Wave Divider at the bottom connecting to the next section */}
        <div
          style={{
            position: "absolute",
            bottom: -1,
            left: 0,
            width: "100%",
            overflow: "hidden",
            lineHeight: 0,
          }}
        >
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            style={{
              position: "relative",
              display: "block",
              width: "100%",
              height: "90px",
            }}
          >
            <path
              d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
              fill="#ffffff"
            ></path>
          </svg>
        </div>
      </section>

      {/* 2. PREMIUM ABOUT SECTION */}
      <section className="premium-about-section">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 mb-5 mb-lg-0 wow fadeInLeft"
              data-wow-duration="1.5s"
            >
              <div className="about-image-wrapper">
                <div className="about-img-shape"></div>
                <img
                  src={aboutPic}
                  alt="Castomech Facility"
                  className="about-img-main"
                />
                <div className="about-stats-box">
                  <div className="about-stats-number">8+</div>
                  <div className="about-stats-text">
                    Years Of <br />
                    Excellence
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-6 pl-lg-5 wow fadeInRight"
              data-wow-duration="1.5s"
            >
              <div className="light-section-label">Who We Are</div>
              <h2 className="light-section-title">
                Pioneering{" "}
                <span className="gradient-text-bold">Foundry Solutions</span>{" "}
                Since 2018
              </h2>
              <p
                style={{
                  color: "var(--text-muted)",
                  fontSize: "18px",
                  lineHeight: 1.8,
                  marginBottom: "30px",
                }}
              >
                Castomech Technology LLP, a proud division of the Plasma Group,
                stands at the forefront of foundry engineering. We don't just
                build machines; we architect solutions that drive monumental
                industrial shifts.
              </p>
              <p
                style={{
                  color: "var(--text-muted)",
                  fontSize: "16px",
                  lineHeight: 1.7,
                  marginBottom: "40px",
                }}
              >
                Specializing in Green Process, Lost Foam Sand Process, and
                Noback-Co2 Sand Process plants, our precision-crafted equipment
                is the silent force behind countless successful foundries
                globally.
              </p>

              <div className="row mt-4">
                <div className="col-sm-6 mb-4">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background: "rgba(255,75,43,0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "var(--brand-orange)",
                        fontSize: "20px",
                      }}
                    >
                      <i className="flaticon-factory"></i>
                    </div>
                    <h5
                      style={{ margin: 0, fontWeight: 700, fontSize: "16px" }}
                    >
                      Global Delivery
                    </h5>
                  </div>
                </div>
                <div className="col-sm-6 mb-4">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background: "rgba(255,75,43,0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "var(--brand-orange)",
                        fontSize: "20px",
                      }}
                    >
                      <i className="flaticon-engineer"></i>
                    </div>
                    <h5
                      style={{ margin: 0, fontWeight: 700, fontSize: "16px" }}
                    >
                      Custom Engineering
                    </h5>
                  </div>
                </div>
              </div>

              <Link to="/about" className="premium-btn mt-2">
                Learn More About Us <i className="ti-arrow-right ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 3. PREMIUM FEATURES GRID */}
      <section className="premium-features-section">
        <div className="container">
          <div className="row justify-content-center mb-5 pb-4">
            <div
              className="col-lg-8 text-center wow fadeInUp"
              data-wow-duration="1.5s"
            >
              <div
                className="light-section-label"
                style={{ justifyContent: "center" }}
              >
                Our Strengths
              </div>
              <h2 className="light-section-title text-center">
                Built on <span className="gradient-text-bold">Excellence</span>
              </h2>
              <p
                style={{
                  color: "var(--text-muted)",
                  fontSize: "18px",
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                We don't just manufacture machinery; we architect solutions that
                drive monumental industrial shifts with a focus on absolute
                perfection.
              </p>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-md-4 mb-4 wow fadeInUp" data-wow-delay="0.2s">
              <div className="premium-feature-card">
                <div className="premium-icon-box">
                  <img
                    src={require("../../images/QualityStandards.png")}
                    alt="Quality"
                    className="premium-icon"
                  />
                </div>
                <h3>Elite Standards</h3>
                <p>
                  Meticulously adhering to international quality metrics. Our
                  manufacturing processes guarantee unparalleled durability even
                  in the harshest industrial environments.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4 wow fadeInUp" data-wow-delay="0.4s">
              <div className="premium-feature-card">
                <div className="premium-icon-box">
                  <img
                    src={require("../../images/ProductionFacility.png")}
                    alt="Facility"
                    className="premium-icon"
                  />
                </div>
                <h3>Advanced Facility</h3>
                <p>
                  Harnessing state-of-the-art CNC and fabrication technologies
                  to deliver millimeter-perfect precision in every single
                  component we craft globally.
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-4 wow fadeInUp" data-wow-delay="0.6s">
              <div className="premium-feature-card">
                <div className="premium-icon-box">
                  <img
                    src={require("../../images/OurTeam.png")}
                    alt="Experts"
                    className="premium-icon"
                  />
                </div>
                <h3>Master Engineers</h3>
                <p>
                  A powerhouse team of seasoned foundry veterans and innovative
                  engineers pushing the boundaries of what specialized heavy
                  machinery can achieve.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. PRODUCTS LIGHT CAROUSEL */}
      <section className="products-light-section">
        <div className="container">
          <div className="row justify-content-between align-items-end mb-5">
            <div className="col-lg-8">
              <div className="light-section-label">Precision Catalog</div>
              <h2 className="light-section-title m-0">
                Our Latest{" "}
                <span className="gradient-text-bold">Innovations</span>
              </h2>
            </div>
         
          </div>
          <div className="row">
            <div className="col-12 project-carousel-wrapper">
              <ProjectSlider1 data={projectContent1} />
            </div>
          </div>
        </div>
      </section>

      {/* 4. COUNTERS & TRUSTED CLIENTS */}
      <div style={{ backgroundColor: "#ffffff" }}>
        <CounterSection2 backgroundImage={bg2} />
      </div>

      <section
        className="section-full p-t80 p-b80 bg-white"
        style={{
          borderTop: "1px solid var(--border-color)",
          borderBottom: "1px solid var(--border-color)",
        }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <h4
              style={{
                color: "var(--text-muted)",
                textTransform: "uppercase",
                letterSpacing: "3px",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              Trusted by 500+ High-End Clients
            </h4>
          </div>
          <ClientSlider1 hideBorder />
        </div>
      </section>

      {/* Popup Modal */}
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-button" onClick={closePopup}>
              &times;
            </button>
            {alert.type === "success" ? (
              <div className="success-message">
                <div style={{ fontSize: "60px", marginBottom: "20px" }}>✅</div>
                {alert.message}
              </div>
            ) : (
              <>
                <h4 className="popup-title">Get Our Catalogue</h4>
                <p className="popup-subtitle">
                  Enter your details to download the complete brochure.
                </p>
                {alert.type === "error" && (
                  <div className="alert alert-danger mb-4" style={{ borderRadius: "10px", fontSize: "14px" }}>
                    {alert.message}
                  </div>
                )}
                <form onSubmit={handleFormSubmit}>
                  <div className="popup-form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                  <div className="popup-form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@mail.com"
                      required
                    />
                  </div>
                  <div className="popup-form-group">
                    <label>Mobile Number</label>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      placeholder="+91 00000 00000"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <div style={{ transform: "scale(0.9)", transformOrigin: "0 0" }}>
                      <ReCAPTCHA
                        sitekey="6LfJfAgpAAAAAKxWLLAbkYw9Vx1U-WN9fPi66Nsu"
                        onChange={handleRecaptchaChange}
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className={`site-button btn-block ${!captchaToken ? "disabled-button" : ""}`}
                    disabled={!captchaToken}
                    style={{
                      height: "60px",
                      borderRadius: "15px",
                      background: captchaToken ? "var(--brand-orange)" : "#cbd5e1",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "800",
                      letterSpacing: "1px",
                      border: "none",
                      boxShadow: captchaToken ? "0 15px 30px rgba(255, 75, 43, 0.3)" : "none"
                    }}
                  >
                    SUBMIT & DOWNLOAD
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {/* 5. FOOTER */}
      <Footer4 hideContactInfo displayNewsLetter />

      <ScrollToTop className="icon-up" />
    </div>
  );
};

export default Index;
